import { React } from '@gasbuddy/react';
import { Text } from '@gasbuddy/react-components';
import style from './style.css';

interface CategoryEntry {
  category: string;
}

interface CategoryListProps {
  className: string;
  onDetail: () => void;
  categories: CategoryEntry[],
}

export default function CategoryList({ className, onDetail, categories }: CategoryListProps) {
  return (
    <table className={className}>
      <tbody>
        {categories.map(cat => (
          <tr key={cat.category} onClick={() => onDetail(cat)}>
            <td width="80%">
              {cat.category}
              {cat.detail && (
                <button
                  type="button"
                  className={style.linkButton}
                  onClick={(e) => {
                    e.preventDefault();
                    onDetail(cat);
                  }}
                >
                  more info...
                </button>
              )}
            </td>
            <td><Text color="teal">{cat.reward_text}</Text></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
